import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import '../App.css';

const NavBar = () => {
  const location = useLocation();

  const navItems = [
    { path: '/', icon: '▣', label: 'Dashboard' },
    { path: '/swap', icon: '⇄', label: 'Swap' },
    { path: '/staking', icon: '⬡', label: 'Staking' },
    { path: '/space', icon: '◈', label: 'Space' }
  ];

  return (
    <div className="bottom-nav-container">
      <div className="bottom-nav">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`bottom-nav-btn ${isActive ? 'active' : ''}`}
            >
              {isActive && (
                <motion.div
                  className="bottom-nav-bg"
                  layoutId="activeTab"
                  transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
                />
              )}
              <span className="bottom-nav-icon">{item.icon}</span>
              <span className="bottom-nav-label">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default NavBar;
